import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export function FAQ() {
  const { t } = useTranslation();
  const faqItems = t("faq.items", { returnObjects: true }) as Array<{ q: string; a: string }>;

  return (
    <section id="faq" className="bg-gradient-to-b from-gray-50 to-white py-[96px] overflow-hidden">
      <div className="mx-auto max-w-[900px] px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.12em] text-primary">
            {t("faq.tag")}
          </p>
          <h2 className="text-[36px] sm:text-[48px] leading-[1.2] font-bold tracking-[-0.02em] text-gray-900">
            {t("faq.title")}
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="mt-14"
        >
          <Accordion type="single" collapsible defaultValue="item-0" className="space-y-4">
            {faqItems.map((item, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: idx * 0.05 }}
              >
                <AccordionItem
                  value={`item-${idx}`}
                  className="bg-white rounded-xl border border-gray-200 px-1 transition-all duration-200 hover:border-blue-200 hover:shadow-md"
                >
                  <AccordionTrigger className="px-5 py-5 hover:no-underline hover:text-blue-600 text-[16px] font-semibold text-gray-900">
                    <div className="flex items-center gap-3">
                      <div className="w-6 h-6 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center text-[12px] font-bold">
                        {idx + 1}
                      </div>
                      {item.q}
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="px-5 pb-5 pt-1">
                    <motion.p
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 0.3 }}
                      className="text-[15px] text-gray-600 leading-relaxed pl-9 border-l-2 border-blue-200 pl-4"
                    >
                      {item.a}
                    </motion.p>
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
